"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TickerGroup = void 0;
var _reactI18next = require("react-i18next");
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../../../../hooks");
var _ticker = require("../../../../ticker");
var _ui = require("../../../../ui");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TickerGroup = function TickerGroup() {
  var _useTranslation = (0, _reactI18next.useTranslation)('libTransfers'),
    t = _useTranslation.t;
  var _useExchangeContext = (0, _hooks.useExchangeContext)(),
    ticker = _useExchangeContext.ticker,
    tickers = _useExchangeContext.tickers,
    balances = _useExchangeContext.balances,
    setTicker = _useExchangeContext.setTicker;
  return /*#__PURE__*/_react.default.createElement(_ui.FormGroup, null, /*#__PURE__*/_react.default.createElement(_ui.Label, null, t('chooseCurrencyToConvert')), /*#__PURE__*/_react.default.createElement(_ticker.TickerSelectInput, {
    value: ticker,
    tickers: tickers,
    balances: balances,
    onChange: function onChange(value) {
      return setTicker(value);
    }
  }));
};
exports.TickerGroup = TickerGroup;